import { render } from "./KSG.vue?vue&type=template&id=28e3e44c&scoped=true&ts=true"
import script from "./KSG.vue?vue&type=script&lang=ts"
export * from "./KSG.vue?vue&type=script&lang=ts"

import "./KSG.vue?vue&type=style&index=0&id=28e3e44c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/octopus-lobby/octopus-lobby/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28e3e44c"]])

export default __exports__